// please be familiar with react-bootstrap-table-next column formaters
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Work%20on%20Columns&selectedStory=Column%20Formatter&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

export function ActionsColumnFormatter(
  cellContent,
  row,
  rowIndex,
  { openEdit, handleDelete, goPreview }
) {
  const future = new Date(`${row.start_date} ${row.start_time}`);
  const today = new Date();
  function diff_minutes(dt2, dt1) {

    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.round(diff)

  }

  const minuts = diff_minutes(future, today)
  // for example: {year:0,month:0,week:1,day:2,hour:34,minute:56,second:7}
  return (
    <div className="row">
      <a
        title="Preview Campaign"
        className="btn btn-icon btn-light btn-hover-warning btn-sm"
        disabled={row.mode === "draft"}
        onClick={() => {
          goPreview(row.uid)
        }}
      >
        <span className="svg-icon svg-icon-md svg-icon-warning">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")} />
        </span>
      </a>

      <button
        title="Edit Campaign"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => {
          window.location.href = "/campaign/edit/" + row.uid;
        }}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          />
        </span>
      </button>
      <button
        title="Delete Campaign"
        className="btn btn-icon btn-light btn-hover-danger btn-sm"
        onClick={() => handleDelete(row.uid)}
        disabled={minuts < 0}

      >
        <span className="svg-icon svg-icon-md svg-icon-danger">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
        </span>
      </button>
    </div>
  );
}
